import { z } from 'zod';

export enum ImpactCategoryId {
  JOBS = 'S2',
  TAXES = 'S1',
  SOCIETAL_INFRA = 'S3',
  SOCIETAL_STABILITY = 'S5',
  EQUALITY = 'S4',
  KNOWLEDGE_INFRA = 'K2',
  CREATES_KNOWLEDGE = 'K3',
  DISTRIBUTING_KNOWLEDGE = 'K4',
  SCARCE_HUMAN_CAPITAL = 'K1',
  PHYSICAL_DISEASES = 'H1',
  MENTAL_DISEASES = 'H2',
  NUTRITION = 'H3',
  RELATIONSHIPS = 'H4',
  MEANING_AND_JOY = 'H5',
  GHG_EMISSIONS = 'E1',
  NON_GHG_EMISSIONS = 'E2',
  SCARCE_NATURAL_RESOURCES = 'E3',
  BIODIVERSITY = 'E4',
  WASTE = 'E5',
}

export const impactCategoryIds = Object.values(ImpactCategoryId);

// OA: When importing allImpactCodes from ./types.ts,  joi validators started crashing on compile time.
// I didn't research further, because just using Object.values directly here fixed the issue.
export function isImpactCategoryId(input: string | undefined): input is ImpactCategoryId {
  return Object.values(ImpactCategoryId).includes(input as ImpactCategoryId);
}
export const zImpactCategory = z.nativeEnum(ImpactCategoryId);
